import React from 'react';
import MetaData from 'src/config/MetaData';
import RoutePaths from 'src/config/RoutePaths';
import LayoutWrapper from 'src/shared/components/LayoutWrapper';
import ChartSection from './components/ChartSection';
import CommonTypeSection from './components/CommonTypeSection';
import TraditionalVsAlternativeTableSection from 'src/components/TraditionalVsAlternativeTableSection';
import TitleSection from './components/TitleSection';
import styles from './styles.module.scss';

const pageInfo = MetaData[RoutePaths.PRIVATE_MARKET];

const PrivateMarket = () => {
    return (
        <LayoutWrapper
            className={styles.container}
            headerProps={{ type: 'transparent', fixed: true, className: styles.header }}
            metaProps={{ title: pageInfo.title, description: pageInfo.description, keywords: pageInfo.keywords }}
        >
            <div className={styles.page}>
                <TitleSection />
                <TraditionalVsAlternativeTableSection />
                <ChartSection />
                <CommonTypeSection />
            </div>
        </LayoutWrapper>
    );
};

export default PrivateMarket;
